import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
      ]
    },
    Theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
  },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
      },
    EventExtra7: {
      validations: []
    },
    SiteName: {
      validations: []
      },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'},
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Category: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Website: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'FirstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:*',
            options: [
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Bar/Bat Mitzvah', value: 'Bar/Bat Mitzvah' },
              { label: 'Breakfast', value: 'Breakfast' },
              { label: 'Christening', value: 'Christening' },
              { label: 'Christmas Party', value: 'Christmas Party' },
              { label: 'Cocktail Party', value: 'Cocktail Party' },
              { label: 'Engagement Party', value: 'Engagement Party' },
              { label: 'Life Celebration', value: 'Life Celebration' },
              { label: 'Lunch or Dinner', value: 'Lunch or Dinner' },
              { label: 'Breakfast', value: 'Breakfast' },
              { label: 'Christmas Party', value: 'Christmas Party' },
              { label: 'Conference', value: 'Conference' },
              { label: 'Exhibition', value: 'Exhibition' },
              { label: 'Lunch or Dinner', value: 'Lunch or Dinner' },
              { label: 'Morning or Afternoon Tea', value: 'Morning or Afternoon Tea' },
              { label: 'Not for Profit', value: 'Not for Profit' },
              { label: 'Pharmaceutical', value: 'Pharmaceutical' },
              { label: 'Presentation', value: 'Presentation' },
              { label: 'Product Launch', value: 'Product Launch' },
              { label: 'Runway', value: 'Runway' },
              { label: 'Graduation', value: 'Graduation' },
              { label: 'Lunch or Dinner', value: 'Lunch or Dinner' },
              { label: 'Mothers / Fathers Day Breakfast', value: 'Mothers / Fathers Day Breakfast' },
              { label: 'School Formal', value: 'School Formal' },
              { label: 'University Ball', value: 'University Ball' },
              { label: 'Valedictory', value: 'Valedictory' },
            ],
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date - First Preference:*',
            mapping: 'EventDate'
          },
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date - Second Preference:',
            mapping: 'EventExtra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Preferred Venue:',
            options: [
              { label: 'Leonda By The Yarra', value: 'Leonda By The Yarra'},
              { label: 'The Stables at Sages Cottage Farm', value: 'The Stables at Sages Cottage Farm'},
              { label: 'Elmswood Estate', value: 'Elmswood Estate'},
              { label: 'Malvern Town Hall', value: 'Malvern Town Hall'},
            ],
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Number of Guests:*',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Estimated Budget:*',
            options: [
              { label: 'Under $10,000', value: 'Under $10,000' },
              { label: '$10,001 - $20,000', value: '$10,001 - $20,000' },
              { label: '$20,001 - $30,000', value: '$20,001 - $30,000' },
              { label: '$30,001 - $40,000', value: '$30,001 - $40,000' },
              { label: '$40,001 - $50,000', value: '$40,001 - $50,000' },
              { label: '$50,000+', value: '$50,000+' }
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?:*',
            options: [
              { label: 'Attended an Event', value: 'Attended an Event' },
              { label: 'Bride Online', value: 'Bride Online' },
              { label: 'Easy Wedding', value: 'Easy Wedding' },
              { label: 'Family or Friend', value: 'Family or Friend' },
              { label: 'Google Search', value: 'Google Search' },
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Other (please specify below)', value: 'Other (please specify below)' },
            ],
            mapping: 'Category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Details or Comments:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'General Chat Information Form',
    formId: '2022',
    clientKey: '35D2935E-F31C-4AC4-992F-A8FCF4A5D6D4',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://melbourneeventgroup.com.au/thank-you-for-getting-in-touch/',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
